import { render, staticRenderFns } from "./webContent.vue?vue&type=template&id=ba99ecc0&scoped=true&"
import script from "./webContent.vue?vue&type=script&lang=js&"
export * from "./webContent.vue?vue&type=script&lang=js&"
import style0 from "./webContent.vue?vue&type=style&index=0&id=ba99ecc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba99ecc0",
  null
  
)

export default component.exports